import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchLaundryPendingPayment = createAsyncThunk(
  "laundryPendingPayment/fetchLaundryPendingPayment",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/laundry/pay-on-delivery-orders", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const laundryPendingPaymentSlice = createSlice({
  name: "laundryPendingPayment",
  initialState: {
    laundryPendingPayments: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLaundryPendingPayment.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchLaundryPendingPayment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.laundryPendingPayments = action.payload.data;
      })
      .addCase(fetchLaundryPendingPayment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch laundryPendingPayments";
      });
  },
});

export default laundryPendingPaymentSlice.reducer;
